/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon, ModalCloseButton, VFlow } from 'bold-ui'
import { resolveName } from 'components/form'
import { MutableRefObject } from 'react'
import { useForm } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoPerguntasMap } from '../consultaSeguimentoPerguntasMap'
import { ConsultaSeguimentoAplicacaoModel, ConsultaSeguimentoFieldModel } from '../model-consultaSeguimento'
import { getPerguntaAtiva, getPerguntaPrevStatus } from '../utils-consultaSeguimento'

interface ConsultaSeguimentoModalTabAdicionarProps {
  path: MetaPath<ConsultaSeguimentoAplicacaoModel>
  values: ConsultaSeguimentoFieldModel
  backToSelecaoButtonRef: MutableRefObject<HTMLButtonElement>
  backQuestionButtonRef: MutableRefObject<HTMLButtonElement>
  onGoBackToSelecao: () => void
}

export function ConsultaSeguimentoModalTabAdicionar(props: Readonly<ConsultaSeguimentoModalTabAdicionarProps>) {
  const { path, values, backToSelecaoButtonRef, backQuestionButtonRef, onGoBackToSelecao } = props

  const { change } = useForm<ConsultaSeguimentoFieldModel>()

  const { perguntaAtiva, indexOfPerguntaAtiva, isFirstPergunta } = getPerguntaAtiva(values.aplicacao)
  const { Field } = ConsultaSeguimentoPerguntasMap[perguntaAtiva]

  const handlePrevious = () => {
    if (!isFirstPergunta) {
      const prevPergunta = values.perguntasSelecionadas[indexOfPerguntaAtiva - 1]
      change(resolveName(path), {
        ...values.aplicacao,
        [perguntaAtiva]: {
          ...values.aplicacao[perguntaAtiva],
          status: getPerguntaPrevStatus(values.aplicacao[perguntaAtiva].status),
        },
        [prevPergunta]: {
          ...values.aplicacao[prevPergunta],
          status: getPerguntaPrevStatus(values.aplicacao[prevPergunta].status),
        },
      })
    }
  }

  return (
    <VFlow vSpacing={2}>
      <HFlow alignItems='flex-start' justifyContent='space-between'>
        {isFirstPergunta ? (
          <Button kind='normal' size='small' innerRef={backToSelecaoButtonRef} onClick={onGoBackToSelecao}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar à seleção
          </Button>
        ) : (
          <Button kind='normal' size='small' innerRef={backQuestionButtonRef} onClick={handlePrevious}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar
          </Button>
        )}
        <ModalCloseButton />
      </HFlow>
      <VFlow>
        <Heading level={1}>Entrevista de seguimento</Heading>
        <Field name={path[perguntaAtiva]} perguntasSelecionadas={values.perguntasSelecionadas} />
      </VFlow>
    </VFlow>
  )
}

const styles = {
  backIcon: css`
    margin-right: 0.5rem;
  `,
}
